import { Box, MantineStyleProp } from '@mantine/core'
import { FC } from 'react'

const MapControlBox: FC<{
  children: React.ReactNode
  position: 'left' | 'right'
  top?: number
  style?: MantineStyleProp
}> = ({ children, position, top = 50, style }) => {
  return (
    <Box
      style={{
        position: 'absolute',
        top: `${top}%`,
        [position]: 20,
        transform: 'translateY(-50%)',
        zIndex: 1000,
        ...style,
      }}
    >
      {children}
    </Box>
  )
}

export default MapControlBox
